import {
  getUsernameForOTPRedux, setUsernameForOTPRedux, getPhoneNumber, setPhoneNumberRedux,
  setOpenModalResetByOTPRedux, setLoadingModalResetByOTPRedux, getTimeLeftRedux, setTimeLeftRedux,
  getOtpRedux, setOtpRedux, getOpenRedux, setOpenRedux, getResetFeedbackRedux, setResetFeedbackRedux,
  getConfirmPasswordRedux, setConfirmPasswordRedux, setPasswordRedux, getPasswordResetRedux, getOpenModalResetByOTPRedux, getLoadingModalResetByOTPRedux, getOpenVerifyOTPModalRedux, setOpenVerifyOTPModalRedux
} from "../libs/loginSlice";
import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux"
import axios from 'axios'
import { Button, Modal, Box, OutlinedInput, Alert } from "@mui/material";
import Swal from "sweetalert2";
import { MuiOtpInput } from 'mui-one-time-password-input'
import TabIndexContent from "react-tabindex-content";
import fontColor from "../lib/fontColor";
import LoadingComponent from "../lib/LoadingComponent";
import { getStyle } from "../libs/todoSlice";
import FadeIn from "react-fade-in/lib/FadeIn";


const ResetPasswordByOTP = () => {

  const dispatch = useDispatch()
  const [isValid, setIsValid] = useState(false);
  const [isHaveNumber, setIsHaveNumber] = useState(false);
  const [isHaveUpper, setIsHaveUpper] = useState(false);
  const [isHaveLower, setIsHaveLower] = useState(false);
  const [isHave8Char, setHave8Char] = useState(false);

  // const [timeLeft, setTimeLeft] = useState(20);

  const timeLeft = useSelector(getTimeLeftRedux)
  const setTimeLeft = (action) => {
    dispatch(setTimeLeftRedux({
      timeLeft: action
    }))
  }
  // useEffect(() => {
  //   console.log('timeLeft :>> ', timeLeft);     
  // }, [timeLeft]);

  const usernameforotp = useSelector(getUsernameForOTPRedux)
  const setUsernameForOTP = (action) => {
    dispatch(setUsernameForOTPRedux({
      usernameforotp: action
    }))
  }

  const phonenumber = useSelector(getPhoneNumber)
  const setPhoneNumber = (action) => {
    dispatch(setPhoneNumberRedux({
      phonenumber: action
    }))
  }

  const openModalResetByOTP = useSelector(getOpenModalResetByOTPRedux)
  const setOpenModalResetByOTP = (action) => {
    dispatch(setOpenModalResetByOTPRedux({
      openModalResetByOTP: action
    }))
  }

  const openVerifyOTPModal = useSelector(getOpenVerifyOTPModalRedux)
  const setOpenVerifyOTPModal = (action) => {
    dispatch(setOpenVerifyOTPModalRedux({
      openVerifyOTPModal: action
    }))
  }

  const loadingModalResetByOTP = useSelector(getLoadingModalResetByOTPRedux)
  const setLoadingModalResetByOTP = (action) => {
    dispatch(setLoadingModalResetByOTPRedux({
      loadingModalResetByOTP: action
    }))
  }


  const otp = useSelector(getOtpRedux)
  const setOtp = (action) => {
    dispatch(setOtpRedux({
      otp: action
    }))
  }

  const open = useSelector(getOpenRedux)
  const setOpen = (action) => {
    dispatch(setOpenRedux({
      open: action
    }))
  }

  const resetFeedback = useSelector(getResetFeedbackRedux)
  const setResetFeedback = (action) => {
    dispatch(setResetFeedbackRedux({
      resetFeedback: action
    }))
  }

  const confirmpassword = useSelector(getConfirmPasswordRedux)
  const setConfirmPassword = (action) => {
    dispatch(setConfirmPasswordRedux({
      confirmpassword: action
    }))
  }

  const password = useSelector(getPasswordResetRedux)
  const setPassword = (action) => {
    dispatch(setPasswordRedux({
      passwordReset: action
    }))
  }

  const style = useSelector(getStyle)

  useEffect(() => {
    setOtp('')
    setPassword('')
    setPhoneNumber('')
  }, [])

  const resetByOtp = async () => {
    setLoadingModalResetByOTP(true);
    await axios({
      method: 'POST',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/password/reset/send-otp`,
      data: {
        username: usernameforotp,
        mobile_no: phonenumber,
      }
    }).then(({ data, status }) => {
      setResetFeedback({
        message: 'ส่ง otp สำเร็จ',
        color: 'success'
      })
      let timeLeftTemp = 20
      const interval = setInterval(() => {
        timeLeftTemp--
        setTimeLeft(timeLeftTemp);
      }, 1000);
      setTimeout(() => {
        clearInterval(interval);
        setTimeLeft(20);
      }, 20000);
      setTimeout(() => {
        setOpenVerifyOTPModal(true)
        setOpen(true)
        setLoadingModalResetByOTP(false)
        setResetFeedback({
          message: '',
          color: ''
        })
      }, 2000);
    }, ({ response }) => {
      setResetFeedback({
        message: 'ข้อมูลไม่ถูกต้อง',
        color: 'error'
      })
      setTimeout(() => {
        setResetFeedback({
          message: '',
          color: ''
        })
      }, 5000);
      setLoadingModalResetByOTP(false)
    })
  }

  const resetCheckPassword = async () => {
    if (password === confirmpassword) {
      setLoadingModalResetByOTP(true)
      await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/password/reset/otp`,
        data: {
          otp: otp,
          new_password: password,
          confirm_new_password: confirmpassword
        }
      }).then(({ data, status }) => {
        setOpenModalResetByOTP(false);
        setOpen(false)
        Swal.fire({
          title: 'เปลี่ยนรหัสผ่านสำเร็จแล้ว',
          icon: 'success'
        })
        setResetFeedback({
          message: 'รีเซ็ตสำเร็จ',
          color: 'success'
        })
        setOpenVerifyOTPModal(false)
        setLoadingModalResetByOTP(false)
      }, ({ response }) => {
        // setOpenVerifyOTPModal(false)
        // setOpen(false)

        setResetFeedback({
          message: 'รีเซ็ตไม่สำเร็จ',
          color: 'error'
        })
        setLoadingModalResetByOTP(false)
        setTimeout(() => {
          setResetFeedback({
            message: '',
            color: ''
          })
        }, 5000);
      })
    } else {
      setOpenVerifyOTPModal(false)
      setOpen(false)
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'รหัสผ่านไม่ตรงกัน'
      })
    }
  }


  return (
    <React.Fragment>
      <Button
        variant="contained"
        style={{
          background: !!style.secondary_color ? `${style.secondary_color}` : 'rgb(5, 48, 117)',
          color: style.secondary_color ? fontColor(style.secondary_color) : '#FFFFFF',
          borderRadius: '6px',
          width: '160px',
          height: '36px',
        }}
        onClick={() => {
          setOpenModalResetByOTP(true);
        }}
      >
        รีเซ็ตด้วยเบอร์มือถือ
      </Button>
      <Modal
        open={openModalResetByOTP}
        onClose={() => {
          setOpenModalResetByOTP(false);
        }}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: '16px',
          boxShadow: 24,
          p: 4,
          maxWidth: 500,
          width: '99%',
        }}>
          <TabIndexContent global={true} allowReadOnly={true}>
            <div className="container">
              <div className="row">
                <div className="col">
                  <h6 id="child-modal-title">กรุณากรอก username</h6>
                  <OutlinedInput
                    inputProps={{ tabIndex: '0' }}
                    style={{
                      width: '100%',
                      height: '36px',
                      borderRadius: '6px',
                      border: '1px solid #EEEEEE',
                      marginTop: '10px',
                      marginBottom: '15px'
                    }}
                    placeholder="username"
                    value={usernameforotp}
                    onChange={(e) => {
                      setUsernameForOTP(e.target.value)
                    }}
                    onKeyPress={({ key }) => {
                      if (key === 'Enter' && usernameforotp.length > 0 && phonenumber.length > 0 && timeLeft === 20) {
                        resetByOtp()
                      }
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <h6 id="child-modal-title">กรุณากรอกเบอร์มือถือ</h6>
                  <OutlinedInput
                    inputProps={{
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      maxLength: 10,
                      tabIndex: '1'
                    }}
                    style={{
                      width: '100%',
                      height: '36px',
                      borderRadius: '6px',
                      border: '1px solid #EEEEEE',
                      margin: '10px 0',
                    }}
                    placeholder="เบอร์มือถือ"
                    onChange={(event) => {
                      const newValue = event.target.value.replace(/[^0-9]/g, '');
                      if (newValue.length <= 10) {
                        setPhoneNumber(newValue.startsWith('0') ? newValue : '');
                      }
                    }}
                    value={phonenumber}
                    onKeyPress={({ key }) => {
                      if (key === 'Enter' && usernameforotp.length > 0 && phonenumber.length > 0 && timeLeft === 20) {
                        resetByOtp()
                      }
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div
                    style={{
                      marginBlock: "10px"
                    }}
                  >
                    {resetFeedback.message.length > 0 && <FadeIn><Alert severity={resetFeedback.color}>{resetFeedback.message}</Alert></FadeIn>}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col text-center text-md-end">
                  <Button
                    variant="outlined"
                    style={style.secondary_color ? {
                      color: style.secondary_color,
                      borderColor: style.secondary_color,
                      borderRadius: '6px',
                      width: '90px',
                      height: '36px',
                      marginRight: '10px'
                    } :
                      {
                        color: '#053075',
                        borderColor: '#053075',
                        borderRadius: '6px',
                        width: '90px',
                        height: '36px',
                        marginRight: '10px'
                      }}
                    onClick={() => {
                      setOpenModalResetByOTP(false);
                    }}
                  >
                    กลับ
                  </Button>

                  <Button
                    variant="contained"
                    style={style.secondary_color ? {
                      background: style.secondary_color,
                      color: fontColor(style.secondary_color),
                      borderRadius: '6px',
                      width: '90px',
                      height: '36px'
                    } :
                      {
                        background: '#053075',
                        color: '#FFFFFF',
                        borderRadius: '6px',
                        width: '90px',
                        height: '36px'
                      }}
                    onClick={() => {
                      resetByOtp()
                    }}
                    disabled={timeLeft !== 20 || usernameforotp.length === 0 || phonenumber.length < 10}
                  >
                    {loadingModalResetByOTP === false ?
                      timeLeft !== 20 ?
                        timeLeft
                        :
                        <>ยืนยัน</>
                      :
                      <LoadingComponent width={50} height={50} />
                    }
                  </Button>
                </div>
              </div>
            </div>
          </TabIndexContent>
        </Box>
      </Modal>
      <Modal
        open={openVerifyOTPModal}
        onClose={() => {
          setOpenVerifyOTPModal(false)
        }}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: '16px',
          boxShadow: 24,
          p: 4,
          width: 500,
          zIndex: '0'
        }}>
          <h5 id="child-modal-title">กรุณากรอกรหัส OTP</h5>
          <Button
            variant="contained"
            color="warning"
            disabled={loadingModalResetByOTP || timeLeft !== 20}
            onClick={() => {
              resetByOtp()
            }}
          >
            {loadingModalResetByOTP || timeLeft !== 20 ? (
              timeLeft
            ) : (
              <>ส่งรหัส OTP อีกครั้ง</>
            )}
          </Button>
          <TabIndexContent global={true} allowReadOnly={true}>
            <div>
              <MuiOtpInput
                // inputProps={{ 
                //   tabIndex: 0 
                // }}
                style={{
                  margin: '10px 0px'
                }}
                value={otp}
                onChange={(newValue) => {
                  setOtp(newValue)
                }}
                length={6}
              />
            </div>
            <div>
              <h6 id="child-modal-title">รหัสผ่านใหม่</h6>
              <OutlinedInput
                inputProps={{
                  tabIndex: 0,
                  type: 'password',
                }}
                // tabIndex={0}
                style={{
                  width: '400px',
                  height: '36px',
                  borderRadius: '6px',
                  border: '1px solid #EEEEEE',
                  marginTop: '10px',
                  marginBottom: '15px'
                }}
                placeholder="new password"
                onChange={(event) => {
                  const passwordValue = event.target.value;
                  setPassword(passwordValue);

                  const isValidPassword = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*_+]{8,}$/.test(passwordValue);
                  setIsValid(isValidPassword);

                  const haveNumber = /(?=.*\d)/.test(passwordValue);
                  setIsHaveNumber(haveNumber)

                  const haveUpper = /(?=.*[A-Z])/.test(passwordValue);
                  setIsHaveUpper(haveUpper)

                  const haveLower = /(?=.*[a-z])/.test(passwordValue);
                  setIsHaveLower(haveLower)

                  const have8char = /[a-zA-Z0-9!@#$%^&*_+]{8,}/.test(passwordValue);
                  setHave8Char(have8char)
                }}
              />
            </div>
            <div>
              {isHaveNumber ? <Alert variant="outlined" severity="success" style={{ marginBottom: '15px' }}>ต้องมีตัวเลขอย่างน้อย 1 ตัว</Alert> : <Alert variant="outlined" severity="error" style={{ marginBottom: '15px' }}>ต้องมีตัวเลขอย่างน้อย 1 ตัว</Alert>}
              {isHaveUpper ? <Alert variant="outlined" severity="success" style={{ marginBottom: '15px' }}>ต้องมีตัวอักษรพิมใหญ่อย่างน้อย 1 ตัว</Alert> : <Alert variant="outlined" severity="error" style={{ marginBottom: '15px' }}>ต้องมีตัวอักษรพิมใหญ่อย่างน้อย 1 ตัว</Alert>}
              {isHaveLower ? <Alert variant="outlined" severity="success" style={{ marginBottom: '15px' }}>ต้องมีตัวอักษรพิมเล็กอย่างน้อย 1 ตัว</Alert> : <Alert variant="outlined" severity="error" style={{ marginBottom: '15px' }}>ต้องมีตัวอักษรพิมเล็กอย่างน้อย 1 ตัว</Alert>}
              {isHave8Char ? <Alert variant="outlined" severity="success" style={{ marginBottom: '15px' }}>ต้องมีตัวอักษรอย่างน้อย 8 ตัว</Alert> : <Alert variant="outlined" severity="error" style={{ marginBottom: '15px' }}>ต้องมีตัวอักษรอย่างน้อย 8 ตัว</Alert>}
              <h6 id="child-modal-title">ยืนยันรหัสผ่านใหม่</h6>
              <OutlinedInput
                inputProps={{
                  tabIndex: 1,
                  type: 'password',
                }}
                style={{
                  width: '400px',
                  height: '36px',
                  borderRadius: '6px',
                  border: '1px solid #EEEEEE',
                  margin: '10px 0',
                }}
                placeholder="confirm new password"
                onChange={(event) => {
                  const passwordValue = event.target.value;
                  setConfirmPassword(passwordValue);

                  const isValidPassword = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*_+]{8,}$/.test(passwordValue);
                  setIsValid(isValidPassword);


                }}
              />
            </div>
          </TabIndexContent>
          {/* {password !== confirmpassword && <Alert variant="outlined" severity="error" style={{ marginBottom:'15px'}}>รหัสผ่านไม่ตรงกัน</Alert>}
              <Alert>ส่งรหัส OTP สำเร็จ</Alert> */}

          <div
            style={{
              marginBlock: "10px"
            }}
          >
            {resetFeedback.message.length > 0 && <FadeIn><Alert severity={resetFeedback.color}>{resetFeedback.message}</Alert></FadeIn>}
          </div>
          <div>
            {password !== "" && confirmpassword !== "" && password !== confirmpassword ? <p style={{ color: 'red' }}>รหัสผ่านไม่ตรงกัน</p> : <p> </p>}
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
            <Button
              variant="outlined"
              sx={!!style.primary_color ? {
                color: style.secondary_color,
                borderColor: style.secondary_color,
                borderRadius: '6px',
                width: '90px',
                height: '36px',
                marginRight: '10px'
              } : {
                color: '#053075',
                borderColor: '#053075',
                borderRadius: '6px',
                width: '90px',
                height: '36px',
                marginRight: '10px'
              }}
              onClick={() => {
                setOpenVerifyOTPModal(false)
              }}>
              กลับ
            </Button>
            <Button
              variant="contained"
              sx={!!style.primary_color ? {
                backgroundColor: `${style.secondary_color} !important`,
                color: fontColor(style.secondary_color)
              } : {
                background: '#053075', borderRadius: '6px', width: '90px', height: '36px'
              }}
              onClick={resetCheckPassword}
              disabled={!isValid || password !== confirmpassword || otp.length < 6 }
            >
              {loadingModalResetByOTP === false ?
                <>ยืนยัน</>
                :
                <LoadingComponent width={30} height={30} />
              }
            </Button>
          </div>
        </Box>
      </Modal>
    </React.Fragment>
  );
}

export default ResetPasswordByOTP